import { ApplicationTypes, CamlockHole, attachComponent, featureLabels } from 'metalworks-domain'

import {
  ArrowHeadType,
  detailComponent,
  dimensionIndicatorComponent,
  entityHeaderComponent,
  propertyPageComponent,
} from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

import { GenericDistancePropertyPage } from '../ui/property-pages/GenericDistancePropertyPage'
import { bendHoleDimensionIndicatorCoordinates, scaleIndicator } from './common'

export const camlockHoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('CamlockHole')
    .attach(() => {
      return {
        title: featureLabels[CamlockHole.type],
        subtitle: '',
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/camlock-hole.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('CamlockHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <GenericDistancePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('CamlockHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),

  attachComponent
    .withEntity('CamlockHole')
    .withComponent(dimensionIndicatorComponent, 'radius')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Finalization],
    })
    // TODO: memoEval
    .attach(s => {
      return {
        ...bendHoleDimensionIndicatorCoordinates(s, {
          startY: s.width / 2,
          endY: -s.width / 2,
          startX: 0,
          endX: 0,
          startZ: s.$plate.thickness + 0.1,
          endZ: s.$plate.thickness + 0.1,
        }),
        arrowHeadType: ArrowHeadType.CONE,
        arrowHeadSize: 4,
        labelFontSize: scaleIndicator(4, 64, Math.max(s.$plate.$sizeX, s.$plate.$sizeY)),
        label: `R=${s.width / 2}`,
      }
    }),
]
